import getRelativeContrastColor from "./generate-relative-contrasting-color";

const generateSelfContrastingColor = (color: string): string => {

	return getRelativeContrastColor(color, color);
};

export default generateSelfContrastingColor;
